<template>
  <el-input
    v-model="textAreaValue"
    :disabled="disabled"
    :rows="rows"
    type="textarea"
  />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'TextAreaWithArray',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 4
    }
  },
  setup(props, context) {
    const textAreaValue = computed({
      get: () => {
        return props.modelValue.join('\n')
      },
      set: (newVal) => {
        if (!newVal.length) {
          return context.emit('update:modelValue', [])
        }
        context.emit('update:modelValue', newVal.split('\n'))
      }
    })

    return { textAreaValue }
  }
})
</script>
